import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CommandDeck from "@/pages/CommandDeck";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CommandDeck />} />
          <Route path="/admin" element={<AdminLeads />} />
        </Routes>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(212,175,55,0.25)",
              color: "#FAFAFA",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
